import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { COMPANY, NAV_LINKS, SOCIALS } from "../../data/content";

const SOCIAL_ICONS = { instagram: Instagram, facebook: Facebook, linkedin: Linkedin };

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-black/10 bg-white pb-28 md:pb-0">
    <div className="mx-auto max-w-7xl px-5 py-10 md:py-16 lg:px-8">
      <div className="grid gap-8 md:grid-cols-2 md:gap-12 lg:grid-cols-4">
        <div>
          <Logo className="h-12 w-auto" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-bati-ink/60">
            Entreprise de rénovation tous corps d'état. Nous accompagnons vos projets de A à Z, à Paris et en Île-de-France.
          </p>
          <div className="mt-6 flex gap-3">
            {SOCIALS.map((s) => {
              const Icon = SOCIAL_ICONS[s.key];
              return (
                <a
                  key={s.key}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-${s.key}`}
                  aria-label={s.name}
                  className="grid h-10 w-10 place-items-center border border-black/10 text-bati-ink/60 transition-colors duration-300 hover:border-bati-sky hover:text-bati-sky"
                >
                  <Icon className="h-4 w-4" />
                </a>
              );
            })}
          </div>
        </div>
        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.14em] text-bati-blue">Contact</h3>
          <ul className="mt-5 space-y-4 text-sm">
            <li>
              <a href={COMPANY.phoneHref} data-testid="footer-phone" className="flex items-start gap-3 font-semibold text-bati-ink transition-colors hover:text-bati-sky">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-bati-sky" /> {COMPANY.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="flex items-start gap-3 text-bati-ink/70 transition-colors hover:text-bati-sky">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-bati-sky" /> {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-bati-ink/70">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-bati-sky" />
              <span>{COMPANY.address}<br />{COMPANY.city}</span>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.14em] text-bati-blue">Navigation</h3>
          <ul className="mt-5 space-y-3 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-bati-ink/70 transition-colors hover:text-bati-sky">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.14em] text-bati-blue">Zone d'intervention</h3>
          <p className="mt-5 text-sm leading-relaxed text-bati-ink/70">{COMPANY.zone}.</p>
          <p className="mt-2 text-sm leading-relaxed text-bati-ink/60">
            Paris (75), Seine-et-Marne (77), Yvelines (78), Essonne (91), Hauts-de-Seine (92), Seine-Saint-Denis (93), Val-de-Marne (94), Val-d'Oise (95).
          </p>
        </div>
      </div>
      <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-black/10 pt-6 text-xs text-bati-ink/50 md:mt-14 md:flex-row md:items-center">
        <p>© {new Date().getFullYear()} {COMPANY.name} — Tous droits réservés.</p>
        <div className="flex gap-6">
          <Link to="/mentions-legales" data-testid="footer-legal-link" className="transition-colors hover:text-bati-sky">Mentions légales</Link>
          <Link to="/politique-confidentialite" data-testid="footer-privacy-link" className="transition-colors hover:text-bati-sky">Politique de confidentialité</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
